import useSWR from 'swr';
import axiosInstance from '@api/axios.ts';
import { backendDateFormat } from '@utils/utils';

import { AdminCreditUsage } from '@features/admin-credit-usage/types';

interface UseAdminCreditUsageDataParams {
  creditType: string;
  interval: string;
  startDate: Date | null;
  endDate: Date | null;
}

interface CreditUsageData extends Array<AdminCreditUsage> {}

const fetcher = async (url: string): Promise<CreditUsageData> => {
  try {
    const res = await axiosInstance({
      method: 'GET',
      url,
    });
    return res.data;
  } catch (error: any) {
    // For now, return empty data if endpoint doesn't exist
    console.warn('Credit usage admin endpoint not yet implemented:', error);
    return [];
  }
};

const useAdminCreditUsageData = (params: UseAdminCreditUsageDataParams) => {
  const { creditType, interval, startDate, endDate } = params;

  // Build query parameters
  const queryParams = new URLSearchParams();
  if (creditType !== 'all') queryParams.append('credit_type', creditType);
  queryParams.append('interval', interval);
  if (startDate) {
    queryParams.append('start_date', backendDateFormat(startDate));
  }
  if (endDate) {
    queryParams.append('end_date', backendDateFormat(endDate));
  }

  // NOTE: This endpoint doesn't exist yet - needs to be created in backend
  // Expected endpoint: GET /api/admin/credit-usage/?credit_type=case&interval=day&...
  const url = `/api/admin/credit-usage/?${queryParams.toString()}`;

  const { data, isLoading, error } = useSWR<CreditUsageData>(url, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: true,
  });

  return {
    data,
    isLoading,
    error: error as Error | null,
    isError: !isLoading && !data && error,
  };
};

export default useAdminCreditUsageData;
